import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BookingsComponent } from './bookings/bookings.component';
import { AdminLoginComponent } from './admin-login.component';
import { AdminDashboardComponent } from './admin-dashboard.component';
import { AdminRouterComponent } from './admin-router.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingDetailsComponent } from './bookings/booking-details.component';
import { LayoutModule } from '@angular/cdk/layout';

@NgModule({
  declarations: [AdminRouterComponent, AdminLoginComponent, BookingsComponent, AdminDashboardComponent, BookingDetailsComponent],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatIconModule,
    LayoutModule
  ],
  exports: [
    AdminRouterComponent
  ]
})
export class AdminModule { }
